import request from "@/utils/request";

export function permissionList(role) {
  const params = {};
  if (role) {
    params.role = role;
  }
  return request.get('/permissions/', { params });
}

export function permissionAppend(data) {
  return request.post('/permissions/', data);
}

export function permissionId(id) {
  return request.get(`/permissions/${id}/`);
}

export function permissionUpdate(id, data) {
  return request.put(`/permissions/${id}/`, data);
}

export function permissionDelete(id) {
  return request.delete(`/permissions/${id}/`);
}

export function permissionDeleteRole(id, role) {
  return request.delete(`/permissions/${id}/roles/${role}/`);
}

export function permissionTree() {
  return request.get('/permissions/tree/');
}

export function permissionUser() {
  return request.get('/permissions/user/');
}
